/**
 * CSS-only konfeti animasyonu.
 * Üst kısımdan rastgele renklerde 50 kare düşer.
 */

import { useMemo } from 'react'

interface Props {
  /** Konfeti parça sayısı (default 50) */
  adet?: number
  /** Animasyon süresi (saniye) */
  sure?: number
}

const RENKLER = [
  '#ef4444', '#f59e0b', '#eab308', '#22c55e',
  '#06b6d4', '#3b82f6', '#8b5cf6', '#ec4899',
  '#f43f5e', '#10b981',
]

export function Konfeti({ adet = 50, sure = 6 }: Props) {
  const partikuller = useMemo(() => {
    return Array.from({ length: adet }).map((_, i) => ({
      id: i,
      sol: Math.random() * 100,
      gecikme: Math.random() * sure,
      renk: RENKLER[Math.floor(Math.random() * RENKLER.length)],
      donme: Math.random() * 360,
      boyut: 6 + Math.random() * 8,
    }))
  }, [adet, sure])

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-50">
      <style>{`
        @keyframes dogum-konfeti-dus {
          0% {
            transform: translateY(-20vh) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(110vh) rotate(720deg);
            opacity: 0;
          }
        }
      `}</style>
      {partikuller.map((p) => (
        <div
          key={p.id}
          style={{
            position: 'absolute',
            left: `${p.sol}%`,
            top: 0,
            width: `${p.boyut}px`,
            height: `${p.boyut}px`,
            backgroundColor: p.renk,
            borderRadius: p.id % 3 === 0 ? '50%' : '2px',
            transform: `rotate(${p.donme}deg)`,
            animation: `dogum-konfeti-dus ${sure}s linear ${p.gecikme}s infinite`,
          }}
        />
      ))}
    </div>
  )
}
